import {
  Box,
  Button,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "../../../../../components";

const ErrosBoletoDialog = ({ open, setOpen, erros }) => {
  const mensagensErro = erros?.length
    ? erros
        .split(";")
        .map((erro) => erro.trim())
        .filter(Boolean)
    : "";

  function onClose() {
    setOpen(false);
  }

  return (
    <Dialog fullWidth maxWidth={"sm"} open={open} onClose={onClose}>
      <CardHeader title="OBSERVAÇÕES" className="m-2" />
      <DialogContent>
        <Box
          sx={{
            background: "#B71C1C17",
            border: "1px solid #B71C1C47",
            borderLeft: "5px solid #B71C1C",
            borderRadius: 2,
            padding: { xs: 1.5, sm: 2.5 },
            marginBottom: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              marginBottom: 2,
            }}
          >
            <i
              className="ph-fill ph-warning-circle"
              aria-hidden="true"
              style={{ color: "#B71C1C", fontSize: 28, lineHeight: 1 }}
            ></i>
            <Typography
              variant="subtitle1"
              sx={{ color: "#B71C1C", fontWeight: 700, lineHeight: 1.3 }}
            >
              Falha na emissão do boleto
            </Typography>
          </Box>

          {mensagensErro.length > 0 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                listStyle: "none",
                margin: 0,
                padding: 0,
              }}
            >
              {mensagensErro.map((mensagem, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.25,
                    padding: 2,
                    backgroundColor: "#FFF",
                    border: "1px solid #B71C1C30",
                    borderRadius: 1.5,
                  }}
                >
                  <Typography
                    sx={{
                      flex: "0 0 auto",
                      display: "grid",
                      placeItems: "center",
                      width: 24,
                      height: 24,
                      borderRadius: "50%",
                      backgroundColor: "#FDE8E7",
                      color: "#B71C1C",
                      fontSize: 14,
                      fontWeight: 700,
                    }}
                  >
                    {index + 1}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "black",
                      lineHeight: 1.6,
                      fontSize: 14,
                      textAlign: "justify",
                    }}
                  >
                    {mensagem}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          overflow: "auto",
          position: "sticky",
          bottom: 0,
          margin: 1,
          marginTop: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          color="padrao"
          margin="normal"
          variant="contained"
          onClick={onClose}
          disableElevation
        >
          <i
            className="ph-fill ph-x-circle"
            style={{ fontSize: 22, marginRight: 10 }}
          ></i>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrosBoletoDialog;
